import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
  storageApiRef,
} from '@backstage/core-plugin-api';
import {
  techRadarApiRef,
  TechRadarApi,
} from '@backstage-community/plugin-tech-radar';
import { TechRadarLoaderResponse } from '@backstage-community/plugin-tech-radar-common';

import {
  shortcutsApiRef,
  DefaultShortcutsApi,
} from '@backstage-community/plugin-shortcuts';

import { costInsightsApiRef } from '@backstage-community/plugin-cost-insights';
import { GcpCostInsightsClient } from './lib/GcpCostInsightsClient';

import techRadarData from '../../../tech-radar/data.json';

const customTechRadarApi: TechRadarApi = {
  async load(): Promise<TechRadarLoaderResponse> {
    return {
      ...techRadarData,
      entries: techRadarData.entries.map(entry => ({
        ...entry,
        key: entry.id,
        timeline: entry.timeline.map(t => ({
          ...t,
          date: new Date(t.date),
        })),
      })),
    };
  },
};

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  createApiFactory(techRadarApiRef, customTechRadarApi),
  createApiFactory({
    api: shortcutsApiRef,
    deps: { storageApi: storageApiRef },
    factory: ({ storageApi }) =>
      new DefaultShortcutsApi(storageApi.forBucket('shortcuts')),
  }),
  createApiFactory({
    api: costInsightsApiRef,
    deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
    factory: ({ discoveryApi, fetchApi }) =>
      new GcpCostInsightsClient({ discoveryApi, fetchApi }),
  }),
];
